package pwgs.ui.scenes.projectmembersscene

import kotlinx.browser.window


class ProjectMembersControllerFe(props: ProjectMembersSceneProps, scene: MProjectMembersScene) : AProjectMembersControllerFe(props, scene) {

    override fun createInitialModel() : ProjectMembersSceneModel {
        return ProjectMembersSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onRemoveMemberClicked(userId: String) {
        if (!window.confirm("Are you sure you want to remove this member from the project?")) {
            return
        }

        model.isLoading = true
        this.render(this.model)

        call_removeMember(userId)
    }


}

